import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'

import Text from 'UIKit/Text'
import useWalletAccount from 'hooks/useWalletAccount'
import { Trans, useTranslation } from 'react-i18next'
import { useWalletInfo } from 'state/auth/hooks'
import { Icons } from 'svgs'
import theme from 'theme'
import { colors } from 'theme/colors'
import { formatUsername } from 'utils/stringHelper'
import { StyledActionButton } from '../../../components/styles'

const SwitchAddressToDepositButton = () => {
  const { t } = useTranslation()
  const { wallet, walletInfo, onConnectByWalletType } = useWalletInfo()
  const accounts = useWalletAccount()
  const account = accounts[wallet?.type]

  if (!account) {
    return (
      <StyledActionButton width="100%" onClick={onConnectByWalletType}>
        <Text bold fontSize="14px" color={'text'}>
          <Trans>Connect Wallet</Trans>
        </Text>
      </StyledActionButton>
    )
  }

  return (
    <>
      <Flex
        alignItems="center"
        border={`1px solid ${colors.warning}`}
        padding="12px"
        borderRadius={theme.radii.small}
        width={'100%'}
      >
        <Box mr="12px">
          <Icons.WarningIcon width="24px" fill={colors.warning} />
        </Box>

        <Text bold fontSize="12px" color="warning" textAlign="center" lineHeight="16px">
          {t('It seems your wallet connected is active different address, please switch to account {{account}}', {
            account: formatUsername(wallet.address),
          })}
        </Text>
      </Flex>

      {walletInfo.adapter instanceof WalletConnectConnector && (
        <StyledActionButton mt="12px" width="100%" onClick={onConnectByWalletType}>
          <Text bold fontSize="14px" color={'text'}>
            <Trans>Switch account</Trans>
          </Text>
        </StyledActionButton>
      )}
    </>
  )
}

export default SwitchAddressToDepositButton
